import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import type { FilterSpec } from "./specs.ts";

/** This month as "YYYY-MM" (UTC, like the API's month bounds). */
export function currentMonth(): string {
  return new Date().toISOString().slice(0, 7);
}

/** "2026-10" as "October 2026". */
export function monthLabel(month: string): string {
  const d = new Date(`${month}-01T00:00:00`);
  return Number.isNaN(d.getTime()) ? month : d.toLocaleDateString(undefined, { month: "long", year: "numeric" });
}

/** A pinned "Month" pill on the `month` param; absent means this month. */
export function monthFilterSpec(): FilterSpec {
  return {
    kind: "custom",
    key: "month",
    label: "Month",
    params: ["month"],
    pinned: true,
    summary: (get) => monthLabel(get("month") ?? currentMonth()),
    active: (get) => !!get("month"),
    renderEditor: ({ get, set }) => (
      <Box sx={{ p: 1.5 }}>
        <TextField
          type="month"
          size="small"
          fullWidth
          autoFocus
          value={get("month") ?? currentMonth()}
          onChange={(e) => {
            const value = e.target.value;
            set({ month: value && value !== currentMonth() ? value : null });
          }}
          slotProps={{ htmlInput: { "aria-label": "Month" } }}
        />
      </Box>
    ),
  };
}
